import logo from './logo.svg';
import './App.css';
import { Resizable } from './components/Resizable';

function App() {
  return (
    <div className="App">
     <Resizable/>
    </div>
  );
}

export default App;
